import { PHOTO_TRAY_PREVIEW_ESCAPE_DISMISS_EVENT } from '../photo-tray-hover-preview'

/** WMPCM-11796 — host Escape chain closes tray hover previews without deselecting the canvas. */
export function dispatchPhotoTrayPreviewEscapeDismiss(): void {
  window.dispatchEvent(new CustomEvent(PHOTO_TRAY_PREVIEW_ESCAPE_DISMISS_EVENT))
}
